import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Check } from 'lucide-react';
const modules = [{
  num: '01',
  title: 'EL PASO DE ESTUDIANTE A PROFESIONAL',
  items: ['Inseguridad clínica', 'Síndrome impostor', 'Identidad profesional', 'Confianza clínica', 'Construcción de mirada profesional'],
  insight: 'Empezá a sentirte más segura en tu rol profesional.',
  color: 'bg-pink-50',
  textColor: 'text-pink-700'
}, {
  num: '02',
  title: 'ARMAR TU DISPOSITIVO CLÍNICO',
  items: ['Consultorio', 'Encuadre clínico', 'Organización profesional', 'Matrícula y obras sociales', 'Recursos básicos'],
  insight: 'Construí una base clínica clara y organizada.',
  color: 'bg-rose-50',
  textColor: 'text-rose-700'
}, {
  num: '03',
  title: 'EL PRIMER CONTACTO CON EL PACIENTE',
  items: ['Motivo de consulta', 'Entrevistas familiares', 'Primeras observaciones', 'Consentimiento informado', 'Límites y acuerdos'],
  insight: 'Aprendé a recibir consultas reales con más claridad.',
  color: 'bg-fuchsia-50',
  textColor: 'text-fuchsia-700'
}, {
  num: '04',
  title: 'EVALUACIÓN PSICOPEDAGÓGICA',
  items: ['Observación clínica', 'Hipótesis', 'Evaluación como proceso', 'Escucha clínica', 'Técnicas iniciales'],
  insight: 'Empezá a pensar clínicamente más allá de las pruebas.',
  color: 'bg-purple-50',
  textColor: 'text-purple-700'
}, {
  num: '05',
  title: 'INTERVENCIÓN Y PRIMERAS SESIONES',
  items: ['Planificación', 'Estrategias', 'Organización de sesiones', 'Recursos prácticos', 'Acompañamiento clínico'],
  insight: 'Organizá tus intervenciones con más seguridad.',
  color: 'bg-amber-50',
  textColor: 'text-amber-700'
}, {
  num: '06',
  title: 'INFORMES Y DEVOLUCIONES',
  items: ['Redacción clínica', 'Escritura profesional', 'Devoluciones claras', 'Organización de información', 'Comunicación profesional'],
  insight: 'Aprendé a comunicarte con claridad y seguridad.',
  color: 'bg-sky-50',
  textColor: 'text-sky-700'
}, {
  num: '07',
  title: 'FAMILIAS Y LÍMITES',
  items: ['Comunicación con familias', 'Sostén profesional', 'Límites claros', 'Reuniones', 'Trabajo interdisciplinario'],
  insight: 'Sostené vínculos sin desbordarte emocionalmente.',
  color: 'bg-emerald-50',
  textColor: 'text-emerald-700'
}, {
  num: '08',
  title: 'ORGANIZACIÓN PROFESIONAL',
  items: ['Herramientas clínicas', 'Organización diaria', 'Recursos de trabajo', 'Crecimiento profesional', 'Práctica sostenible'],
  insight: 'Construí una práctica más organizada y tranquila.',
  color: 'bg-rose-50',
  textColor: 'text-rose-700'
}];
export function ModulesSection() {
  return <section className="py-16 bg-slate-50" data-id="element-113">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-114">
        <div className="text-center mb-12" data-id="element-115">
          <span className="text-pink-600 font-bold tracking-widest text-sm uppercase mb-2 block" data-id="element-116">
            ¿Qué incluye?
          </span>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-navy-900 uppercase tracking-tight mb-3" data-id="element-117">
            📘 Ebook principal
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-118">
            Más de 200 páginas organizadas para acompañarte paso a paso en la
            práctica clínica real.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-119">
          {modules.map((mod, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i % 4 * 0.05
        }} className={`rounded-3xl p-7 border border-slate-100 ${mod.color}`} data-id="element-120">
              <div className="flex items-center gap-3 mb-3" data-id="element-121">
                <BookOpen className={`w-6 h-6 ${mod.textColor}`} data-id="element-122" />
                <span className={`font-bold tracking-widest text-sm uppercase ${mod.textColor}`} data-id="element-123">
                  🌸 Módulo {mod.num}
                </span>
              </div>
              <h3 className="font-bold text-navy-900 text-lg mb-4 uppercase tracking-tight leading-snug" data-id="element-124">
                {mod.title}
              </h3>
              <ul className="space-y-2 mb-5" data-id="element-125">
                {mod.items.map((item, j) => <li key={j} className="flex items-start gap-2 text-sm" data-id="element-126">
                    <Check className={`w-4 h-4 ${mod.textColor} shrink-0 mt-0.5`} data-id="element-127" />
                    <span className="text-slate-700 font-medium" data-id="element-128">{item}</span>
                  </li>)}
              </ul>
              <p className="text-sm font-semibold text-slate-700 bg-white/60 rounded-xl px-4 py-3" data-id="element-129">
                💡 {mod.insight}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}